<template>
    <modal
        name="chooseEmployeesModal"
        data-test-id="chooseEmployeesModal"
        :clickToClose="!order || shiftOpened"
        width="50%"
        height="95%"
    >
        <div class="p-2 wrapper">
            <v-btn
                class="big-close-btn"
                fab
                color="#ececd8"
                @click="closeModal"
            >
                <v-icon aria-label="Close" large>
                    mdi-close
                </v-icon>
            </v-btn>
            <template v-if="order">
                <h3 class="text-center" v-if="cashierInShift">
                    Кассир {{ cashierName }}
                </h3>
                <h2 class="text-center">Выберите, на кого записать заказ:</h2>
            </template>
            <template v-else>
                <template v-if="!shiftOpened">
                    <v-col cols="12" class="text-center">
                        <button
                            type="button"
                            class="btn btn-primary ml-auto mr-auto"
                            @click="openShift"
                        >
                            Открыть смену
                        </button>
                    </v-col>
                    <h2 class="text-center mt-6">
                        Добавить мастеров в свою смену:
                    </h2>
                </template>
                <template v-else>
                    <h2 class="text-center">Добавить мастеров в смену:</h2>
                </template>
            </template>
            <div class="btn-wrapper" v-if="sortedEmployees">
              <template v-for="availableEmployee in sortedEmployees">
                <div
                    class="px-2 pt-4"
                    v-if="availableEmployee.employeeId !== shiftData.id"
                    :key="availableEmployee.employeeId"
                >
                  <input
                      :type="order ? 'radio' : 'checkbox'"
                      :id="'emp-' + availableEmployee.employeeId"
                      :name="'emp-' + availableEmployee.employeeId"
                      :value="availableEmployee.employeeId"
                      v-model="employees"
                      :disabled="
                            availableEmployee.leaved_at ||
                                (order && availableEmployee.isCashier) ||
                                (payment && availableEmployee.isCashier) ||
                                availableEmployee.away
                        "
                  />
                  <label :for="'emp-' + availableEmployee.employeeId">
<!--                    <div-->
<!--                        class="v-avatar v-list-item__avatar grey"-->
<!--                        style="position: absolute; margin-left: 7px;"-->
<!--                    >-->
<!--                      <i-->
<!--                          aria-hidden="true"-->
<!--                          class="v-icon notranslate mdi mdi-account-circle theme&#45;&#45;dark"-->
<!--                          style="font-size: 80px;"-->
<!--                      ></i>-->
<!--                    </div>-->
                    <div
                        class="btn btn-options__checkbox"
                        data-test-id="availableEmployee"
                        :class="{
                                disabled:
                                    availableEmployee.leaved_at ||
                                    availableEmployee.isCashier ||
                                    availableEmployee.away
                            }"
                    >
                      <!-- <img class="rounded-circle z-depth-2 w-100" :src="'https://eu.ui-avatars.com/api/?name=' + availableEmployee.name + '+' + availableEmployee.surname"/> -->
                      <!-- <br/> -->
                      <span class="d-block font-weight-bolder">{{
                          availableEmployee.fullName
                        }}</span>
                      <span
                          v-if="!availableEmployee.away"
                          class="d-block pt-2"
                      >{{ availableEmployee.displayRole }}</span
                      >
                      <span
                          v-else
                          class="d-block pt-2"
                      >Нет на месте <br />
                        Чтобы закрыть ЗН, нужно вернуться
                      </span
                      >
                      <span class="d-block pt-2"
                      >Выиграно мотивити:
                                {{ availableEmployee.winned_motivations }}</span
                      >
                    </div>
                  </label>
                </div>
              </template>
            </div>
            <div class="text-center button-selected">
                <template v-if="order && !payment">
                    <button
                        type="button"
                        data-test-id="selectMaster"
                        class="btn btn-primary ml-auto mr-auto"
                        :disabled="employees && employees.length === 0"
                        @click="sendOrder"
                    >
                        Выбрать
                    </button>
                </template>
                <template v-else-if="!order && payment">
                    <button
                        type="button"
                        class="btn btn-primary ml-auto mr-auto"
                        @click="sendEmployeeId"
                    >
                        Принять оплату
                    </button>
                </template>
                <template v-else-if="shiftOpened">
                    <button
                        type="button"
                        class="btn btn-primary ml-auto mr-auto"
                        @click="attachEmployeesToShift"
                    >
                        Добавить в смену
                    </button>
                </template>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "../../plugins/axios-common";

export default {
    props: {
        order: {
            type: Boolean,
            default: false
        },
        shiftId: {
            type: Number
        },
        payment: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selected: "",
            availableEmployees: [],
            employeesinshift: [],
            employees: [],
            error: "",
            loading: true
        };
    },
    computed: {
        ...mapGetters([
            "userData"
        ]),
        ...mapGetters('shift', [
            "shiftData",
            "shiftInfo",
            "shiftWorkers",
            "shiftAssistants",
        ]),
        shiftOpened() {
            if (this.shiftInfo && this.shiftInfo.basic) {
                return this.shiftInfo.basic.number ? true : false;
            }
            return false;
        },
        sortedEmployees() {
            if (this.employeesinshift || this.availableEmployees) {
                const openedBy =
                    Object.keys(this.shiftInfo).length !== 0
                        ? this.shiftInfo.basic.shiftMasterId
                        : this.userData.id;
                const data = this.order
                    ? this.employeesinshift
                    : this.availableEmployees;
                console.log("datattt", data);
                data.forEach((item, i) => {
                    if (item.employeeId === openedBy) {
                        data.splice(i, 1);
                        data.unshift(item);
                    }
                });

                return this.order
                    ? data
                    : data.filter(
                          item => !this.shiftWorkers.includes(item.employeeId)
                      );
            } else {
                return [];
            }
        },
        cashierInShift() {
            return (
                this.employeesinshift.some(e => e.isCashier === true) &&
                !this.employeesinshift.find(obj => {
                    return obj.isCashier === true;
                }).away
            );
        },
        cashierName() {
            return this.employeesinshift.find(obj => {
                return obj.isCashier === true;
            }).fullName;
        }
    },
    async mounted() {
        if (this.order) {
            this.fetchShiftAvailableEmployees(this.shiftId).then(() =>{
                const basicMaster =  this.employeesinshift.find(employees => {
                  console.log('zxc', this.shiftInfo)
                  if (employees && this.shiftInfo.basic) {
                    return employees?.employeeId === this.shiftInfo.basic.shiftMasterId
                  }
                })
                console.log('master', this.employeesinshift)
                if (!basicMaster?.away && !basicMaster?.leaved_at) {
                  this.employees = this.shiftInfo.basic?.shiftMasterId;
                }
            })
        } else {
            this.fetchWorkshopAvailableEmployees();
        }
    },
    methods: {
        closeModal() {
            this.$modal.hide("chooseEmployeesModal");
        },
        fetchWorkshopAvailableEmployees() {
          //todo выпяздичить в стор
            axios
                .get("/api/cash/workshop/availableemployees")
                .then(response => {
                    this.availableEmployees = response.data.data.employees;
                })
                .catch(error => {
                    console.log(error);
                    this.error = true;
                })
                .finally(() => (this.loading = false));
        },
        fetchShiftAvailableEmployees(shiftId) {
          //todo выпяздичить в стор
        return  axios
                .get(`/api/cash/shift/${shiftId}/employeesinshift`)
                .then(response => {
                    this.employeesinshift = response.data.data.employees;
                    this.$store.commit(
                        "shift/updateEmployeesInShift",
                        response.data.data.employees
                    );
                    return response
                })
                .catch(error => {
                    console.log(error);
                    this.error = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        openShift() {
            this.$store.dispatch("shift/openShift", {
                employees: this.employees
            });
            //todo lacation -> router
            window.location.href = "/";
        },
        attachEmployeesToShift() {
            this.$store.dispatch("shift/attachEmployees", {
                employees: this.employees
            }).then(() => {
              this.$modal.hide("chooseEmployeesModal");
              location.reload();
            })
        },
        sendOrder() {
            this.$emit("clicked", this.employees);
        },
      // todo ебань повторная
        sendEmployeeId() {
            this.$emit("clicked", this.employees);
        }
    }
};
</script>

<style scoped>
.big-close-btn {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 1001;
}

input[type="radio"],
input[type="checkbox"] {
    opacity: 0;
    position: fixed;
    width: 0;
}
.button-selected {
    position: fixed;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
}
.btn-options__checkbox {
    display: table-cell;
    padding: 10px;
    width: 33%;
    height: 6vh;
    border-radius: 15px;
    background-color: #eee;
    vertical-align: middle;
}
.wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-bottom: 100px !important;
}
.btn-wrapper {
    margin-top: 30px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    align-items: flex-start;
    overflow: auto;
}

.btn-options__checkbox:hover {
    box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18),
        0 4px 15px 0 rgba(0, 0, 0, 0.15);
}

.btn-options__checkbox:disabled {
    background-color: #fff;
    box-shadow: 0 5px 11px 0 rgba(200, 200, 200, 0.8),
        0 4px 15px 0 rgba(150, 150, 150, 0.55);
}
.btn-options__checkbox.disabled {
  opacity: 0.35;
}

input[type="radio"]:focus + label,
input[type="checkbox"]:checked + label {
    border-radius: 15px;
}

input[type="radio"]:checked + label > div,
input[type="checkbox"]:checked + label > div {
    background-color: #fffbcd;
    box-shadow: inset 1px 2px 4px 0 rgba(0, 0, 0, 0.4);
}

.btn-primary {
    padding: 10px 30px;
    background: linear-gradient(180deg, #c8fa92 0%, #b5e97c 50%);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
    border-radius: 11px;
    font-size: 20px;
    color: #000;
}
</style>
